import React from 'react';
import PropTypes from 'prop-types';
import { RoutedTabs, NavTab } from 'react-router-tabs';
import './styles.css';

const FirmHeaderNav = props => {
  const { tabs, baseUrl, isEditMode } = props;

  return (
    <RoutedTabs
      className="firm-header-nav__navtabs"
      tabClassName="firm-header-nav__navtab"
      activeTabClassName="firm-header-nav__navtab--selected"
    >
      {tabs.map(t =>
        t.isPinned ? (
          <NavTab
            exact
            key={t.title}
            to={`${baseUrl}${t.alias ? '/' + t.alias : ''}`}
            replace={false}
          >
            {t.title}
          </NavTab>
        ) : (
          (t.isActive || isEditMode) && (
            <NavTab
              exact
              key={t.title}
              to={`${baseUrl}/${t.alias}`}
              replace={false}
            >
              {t.title}
            </NavTab>
          )
        )
      )}
    </RoutedTabs>
  );
};

FirmHeaderNav.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  baseUrl: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default FirmHeaderNav;
